<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <info-card label="نوع الجهة الشريكة"
            :value="getLableType(data.partner_entity)"
            />
        </b-col>  
        
        <b-col md="4" cols="12">
            <info-card label="اسم الجهة الشريكة"
            :value="data.partner_entity_name"
            />
        </b-col>   
        <b-col md="4" cols="12" v-if="data.hasOwnProperty('duration')">
            <info-card label="مدة التعاون"
            :value="`${data.duration} أشهر`"
            />
        </b-col>     
        <b-col md="4" cols="12">
            <info-card
            label="هدف التعاون"
            :value="data.goal_of_cooperation"
            />
        </b-col>   
        <b-col cols="4">
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                وثيقة التعاون
                </div>
                <div>
                <b-button
                    
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:data.file } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col>         
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  methods:{
    getLableType(type){
      switch (type){
        case 'governmental':
          return 'حكومية'
        case 'spiritual':
          return 'روحية'
        case 'ngo':
          return 'منظمة غير حكومية' 
        case 'private':
          return 'خاصة'
        default:
          return ''
      }
    }
  },
  };
  </script>